import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { useQueryUnitPurposes } from 'api/queries';
import { InlineDisplayValue } from 'library/components/controls/display/InlineDisplayValue';
import { TextDisplay } from 'library/components/controls/display/TextDisplay';
import { EmptyTextData } from 'library/types';

export const UnitPurposeDisplay = ({
	unitPurpose,
	inline = false,
}: {
	unitPurpose: string | null;
	inline?: boolean;
}): React.JSX.Element => {
	const { t } = useTranslation('unitCreation');
	const { api } = useProductCenterApi();
	const unitPurposesQuery = useQueryUnitPurposes(api);

	const unitPurposeOption = unitPurpose
		? unitPurposesQuery.data?.find(
				(item) =>
					item.value.localeCompare(unitPurpose, undefined, {
						sensitivity: 'accent',
					}) === 0
			)
		: null;

	const renderDisplay = (label: string, value: EmptyTextData) => {
		return inline ? (
			<InlineDisplayValue
				label={label}
				value={value}
				loading={unitPurposesQuery.isLoading}
			/>
		) : (
			<TextDisplay
				label={label}
				value={value}
				loading={unitPurposesQuery.isLoading}
			/>
		);
	};

	return renderDisplay(
		t('configuration-select-unit-purpose'),
		unitPurposeOption?.text ?? unitPurpose
	);
};
